import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=151077345
export const airwallex_get_ext_info = createAsyncThunk(
  '/live/pay/airwallex_get_ext_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/airwallex_get_ext_info',
      {...store.getState().env.deviceinfo, order_id}
    )
    return resp.data.data
  }
)

export interface InitialStateType {
  out_order_id?: string
  client_secret?: string
  return_url?: string
  customer_id?: string
}

const initialState: InitialStateType = {}

export const Wallet2AirwallexSlice = createSlice({
  name: 'Wallet2Airwallex',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(airwallex_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
      })
    })
  },
})

export const Wallet2AirwallexSliceActions = Wallet2AirwallexSlice.actions
export default Wallet2AirwallexSlice.reducer
export const useWallet2AirwallexState = () => {
  const data = useSelector((state) => state.Animal_Goat)
  return data
}
